/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandardProductDto } from '../../models/backend-standard-product-dto';
import { BackendStandardProductRequestDto } from '../../models/backend-standard-product-request-dto';

export interface SalesStandardProductsUpdate$Params {
  id: number;
  body?: BackendStandardProductRequestDto;
}

export function salesStandardProductsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandardProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandardProductDto>;
    }),
  );
}

salesStandardProductsUpdate.PATH = '/api/sales/standard-products/{id}/';
